import { render, staticRenderFns } from "./SetPaymentPassword.vue?vue&type=template&id=4af3125c&scoped=true"
import script from "./SetPaymentPassword.vue?vue&type=script&lang=js"
export * from "./SetPaymentPassword.vue?vue&type=script&lang=js"
import style0 from "./SetPaymentPassword.vue?vue&type=style&index=0&id=4af3125c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af3125c",
  null
  
)

export default component.exports